import { seoDefaults } from '@src/seo-defaults'
import { startCase } from 'lodash'

export function deriveTitleFromPath(pathname: string): string {
  const pathParts = pathname ? pathname.split('/').filter(Boolean) : []

  if (pathParts.length > 0) {
    const titleParts = pathParts.map(pathPart => {
      if (!pathPart) {
        // Ignore false-y path parts
        return null
      } else if (isValidUUIDv4(pathPart)) {
        // Don't put UUID's in the title
        return null
      } else if (`${parseInt(pathPart)}` == pathPart) {
        // Don't put ID numbers in the title
        return null
      } else if (isAirtableRecordId(pathPart)) {
        // Replace Airtable ID's with generic name
        return 'Details'
      } else {
        // Convert all other values to human-friendly title
        return startCase(pathPart)
      }
    })

    return titleParts.filter(Boolean).reverse().join(' | ')
  } else {
    return seoDefaults.title
  }
}

export function isAirtableRecordId(value) {
  const regex = /^rec[a-zA-Z0-9]{14}$/
  return regex.test(value)
}

export function isValidUUIDv4(uuid) {
  const regex = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
  return regex.test(uuid)
}
